module.exports = __webpack_public_path__ + "img/logo.45ce8c40.png";